import React from "react";
import PropTypes from "prop-types";
import styles from "components/common/drawer.scss";

export const Drawer = ({ children, isDrawerMode, onEndDrawerMode }) => {
  if (!isDrawerMode) {
    return null;
  }
  return (
    <div className={ styles["drawer-container"] }>
      <div className={ styles.drawer }>
        <div className={ styles.close } onClick={ onEndDrawerMode }>+</div>
        { children }
      </div>
      <div className={ styles["close-drawer"] } onClick={ onEndDrawerMode } />
    </div>
  );
};

Drawer.propTypes = {
  children: PropTypes.element.isRequired,
  isDrawerMode: PropTypes.bool.isRequired,
  onEndDrawerMode: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/common/drawer.jsx